var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdmissionLinkImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 12.8044C18 12.1178 17.5578 11.5379 16.9453 11.3195V5.85643L18 5.42159L9 1.81055L0 5.42159L9 9.03266L15.8906 6.27993V11.3195C15.2781 11.5379 14.8359 12.1178 14.8359 12.8044C14.8359 13.433 15.2072 13.9726 15.7395 14.2276L14.8633 16.8563L15.8633 17.19L16.418 15.5261L16.9726 17.19L17.9727 16.8563L17.0964 14.2276C17.6287 13.9726 18 13.433 18 12.8044Z",
    fill: "#D31C4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10.1694L4.25391 8.26367V9.64053C4.25391 11.1438 6.29427 12.2773 9 12.2773C11.7057 12.2773 13.7461 11.1438 13.7461 9.64053V8.26367L9 10.1694Z",
    fill: "#D31C4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmissionLinkImg);
export default __webpack_public_path__ + "static/media/AdmissionLinkImg.860327e476b4e5def1395f99ef138765.svg";
export { ForwardRef as ReactComponent };